module.exports = __webpack_public_path__ + "img/logo.91fc3a9b.png";